<button [ngClass]="{'show': showScroll}"
        (click)="scrollToTop()"
        class="scroll-to-top button">
    <span class="is-hidden-touch">Zum Seitenanfang</span><fa-icon [icon]="faArrowUp" class="ml-2-desktop" role="img" aria-label="Zum Seitenanfang"
></fa-icon>
</button>
